import { render, staticRenderFns } from "./VerseQuickActions.vue?vue&type=template&id=58943542&"
import script from "./VerseQuickActions.vue?vue&type=script&lang=js&"
export * from "./VerseQuickActions.vue?vue&type=script&lang=js&"
import style0 from "./VerseQuickActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CText: require('@chakra-ui/vue').CText, CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex})
